import type {ItemListName} from '@/redux/middleware/googleTagManager/types';

import {SortingOptions} from '@/modules/common/context/QueryParams/models';

const SORT_LIST_NAME_MAP: Record<string, ItemListName> = {
  [SortingOptions.departureDateAsc]: 'offer list - earliest arrival',
  [SortingOptions.durationDesc]: 'offer list - longest duration',
};

export const mapToSortListNameForOffer = (sortBy: string): ItemListName =>
  SORT_LIST_NAME_MAP[sortBy] || 'offer list - lowest price';
